/** @format */

import {Widget, WidgetStat} from 'components/PropertyWidget/model';

import {ValueBox} from 'components/PropertyWidget/style';

import WidgetFormattedNumber from 'components/PropertyWidget/components/WidgetFormattedNumber';

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {PointName} from 'components/charts/multiline-chart/model/common';

import {diff} from 'features/mediaplan-progress/helpers/diff';
import {ratioPercent} from 'features/mediaplan-progress/helpers/ratioPercent';

import getTokenWithSpace from '../../helpers/getTokenWithSpace';
import {ComplexValue, GraphComplexValuesList} from '../../models/common';
import {planSeriesFromChartData} from '../progress-adapter/seriesFromChartData';
import {ratioFactFromChartData} from '../progress-adapter/ratioFactFromChartData';

export interface GetStatsTypeBOptions {
  data: CommonChartData[];
  todayPointName: PointName;
  widget: Widget<ComplexValue>;
  graphComplexValuesList: GraphComplexValuesList;
}

const getStatsTypeB = ({
  todayPointName,
  data,
  widget,
  graphComplexValuesList,
}: GetStatsTypeBOptions): WidgetStat[] => {
  const {
    token: tokenRaw,
    roundNumberBy,
    needSpaceBeforeToken,
    complexRatioPredicate,
    isPositiveRed,
  } = widget;

  if (!complexRatioPredicate) {
    throw new Error('Метод обработки обязателен для виджета этого типа');
  }

  const token = getTokenWithSpace({token: tokenRaw, needSpaceBeforeToken});

  const planAtToday = planSeriesFromChartData(data)[todayPointName] ?? 0;
  const fact = ratioFactFromChartData({data, graphComplexValuesList, complexRatioPredicate});
  const diffValue = diff({plan: planAtToday, fact});
  const diffPercent = ratioPercent(diffValue, planAtToday);

  return [
    {
      heading: (
        <>
          План
          <br />
          недоступен
        </>
      ),
      showConditions: ['unreachable'],
    },
    {
      heading: 'План',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber
            number={planAtToday}
            roundNumberBy={roundNumberBy}
            postfix={token}
          />
        </ValueBox>
      ),
      showConditions: ['common', 'future'],
    },
    {
      heading: 'Факт',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={fact} roundNumberBy={roundNumberBy} postfix={token} />
          <WidgetFormattedNumber
            number={diffValue}
            roundNumberBy={0}
            showPlusMinus
            colorize
            isPositiveRed={isPositiveRed}
          />
          <WidgetFormattedNumber
            number={diffPercent}
            roundNumberBy={1}
            postfix='%'
            showPlusMinus
            colorize
            isPositiveRed={isPositiveRed}
          />
        </ValueBox>
      ),
      showConditions: ['common', 'future'],
    },
    {
      heading: 'Факт',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={fact} roundNumberBy={roundNumberBy} postfix={token} />
        </ValueBox>
      ),
      showConditions: ['unreachable'],
    },
    {
      heading: 'Ср. за период',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={fact} roundNumberBy={roundNumberBy} postfix={token} />
        </ValueBox>
      ),
      showConditions: ['not-kpi'],
    },
  ];
};

export default getStatsTypeB;
